import { useMutation, useQuery } from "@tanstack/react-query";
import { get, handleError, handleResponse, post } from "./base.service";
import { API_ENDPOINTS } from "../constants/endpoints";
import type { ApiBookingPayload, ApiListResponse } from "../types/booking";

export const usePostBookingFormMutation = () =>
  useMutation({
    mutationFn: (payload: ApiBookingPayload) =>
      post(API_ENDPOINTS.POST_BOOKING_FORM, payload),
    onSuccess: handleResponse,
    onError: handleError,
  });

export const useGetHotelListQuery = (queryString: string) =>
  useQuery({
    queryFn: async () => {
      const response = await get(`${API_ENDPOINTS.HOTELS}?${queryString}`);
      return handleResponse(response) as ApiListResponse<{
        id: number;
        name: string;
      }>["data"];
    },
    queryKey: ["hotel-list", queryString],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

export const useGetServiceListQuery = (queryString?: string) =>
  useQuery({
    queryFn: async () => {
      if (!queryString) {
        return { items: [] } as ApiListResponse<{
          id: number;
          name: string;
          type?: string;
          category?: string;
          description?: string;
          cost?: number | string;
          service_mode?: string;
        }>["data"];
      }
      const response = await get(`${API_ENDPOINTS.SERVICES}?${queryString}`);
      return handleResponse(response) as ApiListResponse<{
        id: number;
        name: string;
        type?: string;
        category?: string;
        description?: string;
        cost?: number | string;
        service_mode?: string;
      }>["data"];
    },
    queryKey: ["service-list", queryString ?? null],
    enabled: Boolean(queryString),
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
    staleTime: 0,
  });
